<div class="query-builder darker-panel">
    <div class="query-source-options card" *ngIf="!standalone">
        <div class="query-source-settings" *ngIf="!!querySourceId">
            <i class="material-icons fill">extension</i>
            <label *ngIf="!!querySource.name?.length">
                You are using query <b (click)="openQuerySelectionDialog()">{{ querySource.name }}</b>
            </label>
            <label *ngIf="!querySource.name?.length">
                You are using a <b (click)="openQuerySelectionDialog()">local query</b>
            </label>
        </div>

        <div class="query-source-settings" *ngIf="!querySourceId">
            <i class="material-icons fill">extension</i>
            <label>You are creating a new local query.</label>
        </div>

        <label class="query-source-label" (click)="changeQueryEditionMode()">
            {{ !querySource.name?.length ? "Create named query" : "Detach query" }}
        </label>
        <label class="query-source-label" (click)="openQuerySelectionDialog()">
            {{ !querySourceId ? "Use an existing query" : "Use a different query" }}
        </label>
    </div>

    <div class="query-source-options card" *ngIf="standalone">
        <div class="query-source-settings">
            <i class="material-icons fill">extension</i>
            <label>Query name:</label>
            <input pInputText
                   [(ngModel)]="querySource.name"
                   [pattern]="queryNameValidation"
                   [maxLength]="500"
                   required notEmpty/>
            <div class="p-error">
                <small *ngIf="!querySource.name?.length">Name is required.</small>
            </div>
            <div class="p-error">
                <small *ngIf="querySource.name?.length === 500">
                    Maximum length of 500 characters reached.
                </small>
            </div>
        </div>
    </div>

    <div class="query-editor-container">
        <query-builder-sql-editor [(querySource)]="querySource"
                                  [disabled]="!standalone && !!querySource.name"
                                  (updateQuerySource)="saveDraft()">
        </query-builder-sql-editor>

        <div class="query-editor-utils" *ngIf="!!queryEditor && this.isTopAdmin">
            <p-selectButton
                [options]="queryFilterModeOptions"
                [(ngModel)]="querySource.filterMode"
                optionLabel="icon"
                optionValue="value">
                <ng-template let-item pTemplate="item">
                    <i class="material-symbols-outlined" [pTooltip]="item.label">{{ item.icon }}</i>
                </ng-template>
            </p-selectButton>
        </div>
    </div>

    <div class="query-preview-container" *ngIf="!!querySourceId">
        <h4>Query preview</h4>
        <query-preview *miproLoading="processingQuery"
                       [querySourceId]="querySourceId"
                       [standalone]="true"></query-preview>
    </div>
</div>

<p-dialog styleClass="query-creation-dialog" [(visible)]="queryCreationDialogVisible"
          header="Create Named Query" [modal]="true" (onHide)="cancelQueryCreation()">
    <div class="inputs-group">
        <div class="inputs-group-row">
            <label for="name" class="inputs-group-row-name">Name:</label>
            <div class="inputs-group-row-value">
                <input pInputText id="name" #name
                       [ngModel]="querySource.name"
                       [pattern]="queryNameValidation"
                       [maxLength]="500"
                       required notEmpty/>
            </div>
        </div>
        <div class="inputs-group-row">
            <label for="organizations" class="inputs-group-row-name">Organization:</label>
            <div class="inputs-group-row-value">
                <p-multiSelect [(ngModel)]="organizations"
                               [options]="organizationOptions"
                               dataKey="id"
                               appendTo="body"
                               id="organizations"
                               name="organizations"
                               placeholder="Select organisation">
                </p-multiSelect>
            </div>
        </div>
    </div>

    <p-footer>
        <p-button label="Cancel" styleClass="p-button-outlined" (onClick)="cancelQueryCreation()"></p-button>
        <p-button label="Save" [disabled]="!name.value?.length" (onClick)="createNamedQuery(name.value)"></p-button>
    </p-footer>
</p-dialog>

<p-dialog styleClass="query-options-dialog" [(visible)]="querySourceDialogVisible"
          [modal]="true" (onHide)="cancelQuerySelection()">
    <ng-template pTemplate="header">
        <div class="query-options-dialog-header">
            <h4 class="query-options-dialog-header-text">
                Use Existing Query
            </h4>
            <label class="query-options-dialog-subheader-text">
                Select an existing query from the list below.
            </label>
        </div>
    </ng-template>

    <p-treeTable class="tables-tree"
                 [value]="querySourceOptionsTree"
                 [scrollable]="true"
                 [autoLayout]="true"
                 sortField="label"
                 scrollHeight="flex">
        <ng-template pTemplate="body" let-rowNode>
            <tr class="tree-row" [ttRow]="rowNode">
                <td [class]="getNodeClass(rowNode.node)"
                    (click)="selectQuery(rowNode.node)">
                    <p-treeTableToggler *ngIf="multiSourceOptions()"
                                        [rowNode]="rowNode">
                    </p-treeTableToggler>
                    <label>{{ rowNode.node.label }}</label>
                </td>
            </tr>
        </ng-template>
    </p-treeTable>

    <p-footer>
        <p-button label="Cancel" styleClass="p-button-outlined" (onClick)="cancelQuerySelection()"></p-button>
        <p-button label="Use Query" (onClick)="useSelectedQuery()"></p-button>
    </p-footer>
</p-dialog>